import { Controller } from "@hotwired/stimulus"
import { useClickOutside } from "stimulus-use"

export default class extends Controller {
  static targets = ["menu", "searchInput", "option", "empty"]
  static values = { open: Boolean }

  connect() {
    useClickOutside(this, { element: this.menuTarget })
  }

  toggle() {
    this.openValue = !this.openValue
  }

  close() {
    this.openValue = false
    if (this.hasSearchInputTarget) {
      this.searchInputTarget.value = ''
      this.filter()
    }
  }

  clickOutside(event) {
    if (this.openValue) {
      event.preventDefault()
      this.close()
    }
  }

  openValueChanged() {
    if (this.openValue) {
      this.menuTarget.classList.remove('hidden')
      if (this.hasSearchInputTarget) {
        this.searchInputTarget.value = ''
        this.filter()
        if (!window.matchMedia("(pointer: coarse)").matches) {
          setTimeout(() => this.searchInputTarget.focus(), 10)
        }
      }
    } else {
      this.menuTarget.classList.add('hidden')
    }
  }

  filter() {
    if (!this.hasSearchInputTarget) return

    const query = this.searchInputTarget.value.trim().toLowerCase()

    this.optionTargets.forEach(option => {
      const label = option.dataset.label || ''
      option.classList.toggle('hidden', query !== '' && !label.includes(query))
    })

    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle('hidden', this.visibleOptions.length > 0)
    }

    this.activeIndex = 0
    this.highlight()
  }

  next(event) {
    event.preventDefault()
    this.move(1)
  }

  previous(event) {
    event.preventDefault()
    this.move(-1)
  }

  choose(event) {
    event.preventDefault()
    this.visibleOptions[this.activeIndex]?.click()
  }

  // ── helpers ──────────────────────────────────────────────────────────
  get visibleOptions() {
    return this.optionTargets.filter((o) => !o.classList.contains("hidden"))
  }

  move(delta) {
    const count = this.visibleOptions.length
    if (count === 0) return
    this.activeIndex = (this.activeIndex + delta + count) % count
    this.highlight()
  }

  highlight() {
    const visible = this.visibleOptions
    this.optionTargets.forEach((o) => o.classList.remove("bg-primary/10"))
    if (visible.length === 0) return
    if (this.activeIndex == null || this.activeIndex < 0 || this.activeIndex >= visible.length) {
      this.activeIndex = 0
    }
    const el = visible[this.activeIndex]
    el.classList.add("bg-primary/10")
    el.scrollIntoView({ block: "nearest" })
  }
}
